import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TwilioService {
  private accountSid = environment.twilioAccountSid;
  private authToken = environment.twilioAuthToken;
  private baseUrl = `https://api.twilio.com/2010-04-01/Accounts/${this.accountSid}`;

  // Fetch the list of calls
  getAllCalls(): Promise<any> {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('GET', `${this.baseUrl}/Calls.json`, true);

      // Set Basic Auth header
      xhr.setRequestHeader(
        'Authorization',
        'Basic ' + btoa(`${this.accountSid}:${this.authToken}`)
      );
      xhr.setRequestHeader('Content-Type', 'application/json');

      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            resolve(JSON.parse(xhr.responseText));
          } else {
            reject(`Error: ${xhr.status} - ${xhr.statusText}`);
          }
        }
      };

      xhr.send();
    });
  }

  // Fetch recordings for a specific call
  getCallRecordings(callSid: string): Promise<string | null> {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('GET', `${this.baseUrl}/Calls/${callSid}/Recordings.json`, true);

      xhr.setRequestHeader(
        'Authorization',
        'Basic ' + btoa(`${this.accountSid}:${this.authToken}`)
      );
      xhr.setRequestHeader('Content-Type', 'application/json');

      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            const response = JSON.parse(xhr.responseText);
            if (response.recordings && response.recordings.length > 0) {
              // Use the first recording
              const recordingSid = response.recordings[0].sid;
              const mediaUrl = `${this.baseUrl}/Recordings/${recordingSid}.mp3`;
              resolve(mediaUrl);
            } else {
              resolve(null); // No recordings found
            }
          } else {
            reject(`Error: ${xhr.status} - ${xhr.statusText}`);
          }
        }
      };

      xhr.send();
    });
  }
}
